import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import GoogleAnalytics from 'react-ga'

import DeviceReport from '../DeviceReport'
import { FallbackText } from '../TextElements'

import { ReactComponent as ChevronIcon } from '../graphics/chevron-right.svg'

// Main component ----------------------------------------------------------- //
function LatestMeasurements({ className, devices = [] }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOpen() {
    GoogleAnalytics.event({ category: 'Device measurements', action: 'View' })
    setIsOpen(true)
  }

  function handleClose() {
    setIsOpen(false)
  }

  function showContent() {
    if (devices.length > 0) {
      return (
        <div className="mt2 flex flex-row flex-wrap">
          {devices.map((d, i) => {
            // Use number of device attached to for display
            const displayNumber = d.attachedToNumber
              ? formatMeterNumber(d.attachedToNumber)
              : formatMeterNumber(d.number)

            let hoverText = `Målernummer: ${displayNumber}`

            // Also show the number of the attached device on hover
            if (d.attachedToNumber) {
              hoverText += ` Pulsmodul: ${formatMeterNumber(d.number)}`
            }

            return (
              <div key={d.id} className="w-100">
                <DeviceReport
                  roomName={d.room?.name}
                  measurements={d.lastMeasurements ?? []}
                  displayNumber={displayNumber}
                  hoverText={hoverText}
                  deviceStatus={d.online === 'yes' ? 'ok' : 'alert'}
                  className={i > 0 ? 'mt2 pt2 bt b--light-silver' : undefined}
                />
              </div>
            )
          })}
        </div>
      )
    } else {
      return (
        <p className="mv2 tl">
          <FallbackText>Ingen aktive enheder</FallbackText>
        </p>
      )
    }
  }

  return (
    <div className={cx(className, 'mt3')}>
      <button
        className="bg-transparent bn db w-100 tl pv2 ph0 f6 orange pointer"
        onClick={isOpen ? handleClose : handleOpen}
      >
        <ChevronIcon
          width="6"
          height="10"
          className={cx('ml1 mr2', isOpen && 'rotate-90')}
          style={{
            transition: 'transform 0.1s ease-in-out',
          }}
        />
        Seneste målinger
      </button>
      {isOpen && showContent()}
    </div>
  )
}

LatestMeasurements.propTypes = {
  devices: PropTypes.array,
  className: PropTypes.string,
}

export default LatestMeasurements

// Helper functions --------------------------------------------------------- //

export function formatMeterNumber(number = '') {
  const numberString = number.toString()
  // Only split fully numeric meter numbers with a length in multiples of four
  if (numberString.length % 4 !== 0 || /\D/.test(numberString)) {
    return numberString
  }
  return numberString.replace(/(.{4})(?=.)/g, '$1 ')
}
